import { useEffect, useRef } from 'react';


export default function ImageAsync({ src }) {
    const imgRef = useRef(null);

    useEffect(() => {
        const img = imgRef.current;
        const downloadingImage = new Image();
        downloadingImage.onload = function () {
            img.src = this.src;
        };
        downloadingImage.src = src;
    }, [src]);

    return <img ref={imgRef} />;
}
